export const facebook = "https://www.facebook.com/paintedch"
export const instagram = "https://www.instagram.com/paintedch/"
export const youtube = "https://www.youtube.com"
export const telegram = "https://t.me/paintedch"
